import React, { useEffect, useState } from "react";
import { Card, Button, Container, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PAYMENT } from "../../services/actions";
import { CalendarDots, Clock, CurrencyInr } from "@phosphor-icons/react";
import AppLayout from "../../layouts/AppLayout";
import closeGif from "../../assets/btn_close_animated.gif";

export default function History() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const paymentState = useSelector((state) => state?.paymentState);
  const user = JSON.parse(localStorage.getItem("data") || "{}");

  const [history, setHistory] = useState({});

  useEffect(() => {
    if (user?.customerID) {
      dispatch({
        type: `${PAYMENT}_GET`,
        payload: `payments/0/?customer_number=${user.customerID}`,
      });
    }
  }, [dispatch, user?.customerID]);

  useEffect(() => {
    const group = {};
    const seenOrderIds = new Set();

    const results = paymentState?.data?.data?.results || [];
    {console.log("history status",results)}
    results.forEach((row) => {
      if (seenOrderIds.has(row.order_id)) return;
      seenOrderIds.add(row.order_id);

      const date = new Date(row.created_at);
      const ym = date.toLocaleString("en-US", { year: "numeric", month: "short" });

      row.day = date.toLocaleString("en-US", { day: "2-digit" });
      row.time = date.toLocaleString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      group[ym] = group[ym] || [];
      group[ym].push(row);
    });

    setHistory(group);
  }, [paymentState?.data]);

  const STATUS = {
    PENDING: { text: "Pending", _class: "text-warning" },
    SUCCESS: { text: "Success", _class: "text-success" },
    USER_DROPPED: { text: "User dropped", _class: "text-primary" },
    FAILED: { text: "Failed", _class: "text-danger" },
  };

  // Function to handle receipt view and pass the data via URL
  const handleViewReceipt = (row) => {
    const payload = {
      order_id: row.order_id,
      cf_payment_id: row.cf_payment_id || "",  // Use if available
      reciept_no: row.reciept_no || "",        // If available
      payment_amount: row.payment_amount || "", // Optional if available
      customer_note: row.customer_note || "",  // Optional if available
      payment_completion_time: row.modified_date,
      payment_time: row.time,  // Assuming time is available in the row
      payment_status:row.payment_status,
      payment_message:row.payment_message,
      loan_number:row.loan_number,
    };
 console.log("reciept_no",row.reciept_no)
    // Encode the payload to base64
    const encoded = btoa(JSON.stringify(payload));
    
    // Navigate to the receipt page with the encoded query parameters
    navigate(`/receipt?od=${encoded}`);
  };

  return (
    <AppLayout>
      <div className="app-container">
        <div className="d-flex flex-column pb-5" style={{ minHeight: "100vh" }}>
          <div className="d-flex justify-content-between mx-4 mt-5">
            <h1 className="mb-5 app-title">Payment Portal</h1>
          </div>

          <div className="d-flex gap-4 justify-content-center w-100 mt-2">
            <h5 className="text-muted">Transaction History</h5>
          </div>

          <div className="w-100 d-flex justify-content-end gap-4">
            <Button
              variant="outline-light"
              className="m-2 d-flex align-items-center"
              onClick={() => navigate("/dashboard/")}
            >
              <img src={closeGif} alt="Back" style={{ width: 30, height: 30 }} />
              <span className="ms-2">Back</span>
            </Button>
          </div>

          <div className="w-100 mt-5">
            {Array.isArray(paymentState?.data?.data?.results) &&
              paymentState.data.data.results.length === 0 && (
                <div className="text-center">No loans available</div>
              )}
          </div>

          {Object.keys(history).map((monthKey) => (
            <Container key={monthKey} className="w-100 mb-5 pb-2">
              <h6 className="mb-3">{monthKey}</h6>

              {history[monthKey].map((row) => {
                const status = STATUS[row.payment_status] || {};
                const text = status.text || row.payment_status;
                const _class = status._class || "";

                return (
                  <Card
                    key={row.order_id}
                    className="mb-1 p-3 shadow-sm"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleViewReceipt(row)} // Call the new function on card click
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#eff2f7")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "white")
                    }
                  >
                    <Row className="align-items-center g-1">
                      <Col xs={12} md={6} className="mb-1">
                        <div><b>Order ID:</b> {row.order_id}</div>
                        <div><b>Acc No:</b> {row.loan_number}</div>
                        <div className="d-flex align-items-center gap-2 text-muted">
                          <CalendarDots size={16} />
                          {row.day} | <Clock size={16} />
                          {row.time}
                        </div>
                        <div>{row.customer_note}</div>
                      </Col>

                      <Col xs={6} md={3} className="text-md-center">
                        <div>
                          <b className={`d-flex gap-0 align-items-center ${_class}`}>
                            <CurrencyInr size={16} />
                            {row.payment_amount}
                          </b>
                        </div>
                        <div className={`d-flex gap-0 align-items-center ${_class}`} style={{ fontSize: 14 }}>
                          {text}
                        </div>
                      </Col>

                      <Col xs={6} md={3} className="text-md-end">
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => handleViewReceipt(row)} // Added here too for link click
                        >
                          View Receipt
                        </a>
                      </Col>
                    </Row>
                  </Card>
                );
              })}
            </Container>
          ))}
        </div>
      </div>
    </AppLayout>
  );
}
